import PropTypes from 'prop-types'
import React from 'react'

import {
  Card,
  CountPill,
  CountsBar,
  Mono,
  ResultMessage,
  SectionLabel,
  StatusCell,
  SummaryLine
} from './styles'

const formatSummary = (summary) => {
  if (!summary) return null
  const parts = []
  if (summary.centre) parts.push(`centre=${summary.centre}`)
  if (summary.subject) parts.push(`subject=${summary.subject}`)
  if (summary.start_date) {
    const range =
      summary.end_date && summary.end_date !== summary.start_date
        ? `${summary.start_date} → ${summary.end_date}`
        : summary.start_date
    parts.push(`dates=${range}`)
  }
  if (summary.start_time && summary.end_time) {
    parts.push(`time=${summary.start_time}–${summary.end_time}`)
  }
  if (summary.capacity != null) parts.push(`capacity=${summary.capacity}`)
  if (summary.fee != null) parts.push(`fee=${summary.fee}`)
  return parts.join('  ·  ')
}

const ResultsPanel = (props) => {
  const { result } = props
  if (!result) return null

  const { counts = {}, rows = [], dry_run: dryRun } = result

  return (
    <Card>
      <SectionLabel>results {dryRun ? '(dry run)' : ''}</SectionLabel>
      <CountsBar>
        <CountPill $bg="#e7f5ec" $color="#1f7a3a">
          created: {counts.created || 0}
        </CountPill>
        {dryRun ? (
          <CountPill $bg="#eef2fb" $color="#2f4ea0">
            would-create: {counts.dry_run || 0}
          </CountPill>
        ) : null}
        <CountPill $bg="#fdecec" $color="#a52525">
          errors: {counts.error || 0}
        </CountPill>
        {counts.skipped ? (
          <CountPill>skipped: {counts.skipped}</CountPill>
        ) : null}
      </CountsBar>
      <div style={{ overflowX: 'auto' }}>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily: 'Avenir',
            fontSize: 13
          }}
        >
          <thead>
            <tr>
              <th style={th}>#</th>
              <th style={th}>status</th>
              <th style={th}>message</th>
              <th style={th}>batch uuid</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.row_number}
                style={{ borderBottom: '1px solid #eee' }}
              >
                <td style={td}>{row.row_number}</td>
                <td style={td}>
                  <StatusCell $status={row.status}>{row.status}</StatusCell>
                </td>
                <td style={td}>
                  <ResultMessage>{row.message}</ResultMessage>
                  {row.summary ? (
                    <SummaryLine>{formatSummary(row.summary)}</SummaryLine>
                  ) : null}
                </td>
                <td style={td}>
                  {row.batch_uuid ? <Mono>{row.batch_uuid}</Mono> : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  )
}

const th = {
  textAlign: 'left',
  fontFamily: 'AvenirDemi',
  fontSize: 12,
  color: 'rgba(0,0,0,0.56)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  padding: '8px 12px',
  borderBottom: '1px solid #ddd'
}
const td = { padding: '8px 12px', verticalAlign: 'top' }

ResultsPanel.propTypes = {
  result: PropTypes.object
}

export default ResultsPanel
